module.exports = __webpack_public_path__ + "static/img/4.43a98905.jpg";